import * as React from 'react';
import * as S from './styles';
import * as ErroIcon from 'common/icons/errorIcons';
import {InformationScreenProps, Information } from './types'

const InformationScreen:React.FC<InformationScreenProps> = (props) => {
    const informationToShow : Information[] = [
        {id: "unauthorizedPage",
        image: "unauthorizedPage",
        text: `You are trying to access an unauthorize page. \nYou will be redirected to your dealer’s primary location page...`},
        {id: "authenticationError",
        image: "authenticationError",
        text: `Looks like your account is not fully set up yet to use all of the features available within Listings Manager Advanced.\n\nPlease contact our support team to get your account setup.`},
        {id: "notSyncError",
        image: "syncError",
        text: `The dealership is not synced yet, please sync the dealer to access all the Advanced Listings Management features.`}
    ];
    
    const id = props.match?.params?.id??props.id??'';
    const information : Information|undefined =  informationToShow.find((info: Information) => info.id===id);
    const Image = information ?  ErroIcon[information.image] : ErroIcon["authenticationError"] ;

    return (
        <S.Container
            flexDirectionValue={information?.id === "unauthorizedPage" ? "column" : "row"}
        >
            {information && 
            <>
                <S.Col>
                    <Image/>
                </S.Col>
                <S.Col>
                    <S.Text
                        textAlignValue={information?.id === "unauthorizedPage" ? "center" : "left"}
                        fontSizeValue={information?.id === "unauthorizedPage" ? "20px" : "30px"}
                        colorValue={information?.id === "unauthorizedPage" ? "#a5a5a5" : "#000"}
                    >
                        {information.text}
                    </S.Text>
                </S.Col>
            </>
            }
        </S.Container>
    );
}

export default InformationScreen;